<template>
  <div ref="expenseModal">
    <base-header class="pb-4"/>

    <div class="container-fluid mt--4 pt-5 income-forms">
      <b-row>
        <b-col>
          <b-form-group label="Tarih">
            <b-form-input v-model="expense.date" type="date"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Ara Ödeme Yapılacak Borç">
            <b-form-select v-model="credit_id" :options="history.filter(hist=>hist.type=='credit').map(h=>({
            text:`${h.title} ${h.price}₺ - ${moment(h.last_payment_date).format('DD-MM-YYYY')}`,
            value:h.id
            }))"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label>{{ $t("Ödeme Tipi") }}</label>
            <b-form-select v-model="payment_type" :options="[
                { text: 'Nakit', value: 'cash' },
                { text: 'Kredi Kartı', value: 'credit_cart' },
                { text: 'Havale / EFT', value: 'eft' },
                { text: 'Çoklu Ödeme', value: 'multiple_payment' },
              ]"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Fiyat" v-if="payment_type!='multiple_payment'">
            <b-form-input v-model="expense.price" type="number"/>
          </b-form-group>
          <b-row v-else>

            <b-col md="4">
              <b-form-group>
                <label>{{ $t("Kredi Kartı") }}</label>
                <b-form-input type="number" v-model="payment_types.credit_cart"/>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>{{ $t("Nakit") }}</label>
                <b-form-input type="number" v-model="payment_types.cash"/>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>{{ $t("Havale / EFT") }}</label>
                <b-form-input type="number" v-model="payment_types.eft"/>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-right">
          <b-button @click="hideModal()" variant="secondary">İptal</b-button>
          <b-button variant="primary" class="loading-button" @click="saveExpense"
                    :disabled="$v.$invalid || loadingButton">
            <i v-if="loadingButton" class="fa fa-spinner"></i> Kaydet
          </b-button>
        </b-col>
      </b-row>
    </div>

  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {required} from 'vuelidate/lib/validators'
import moment from "moment";
export default {
  name: 'ExpenseModal',
  props: ['show', 'clientId','history'],
  data() {
    return {
      moment,
      loadingButton: false,
      expense: {
        price: 0
      },
      payment_type: 'cash',
      payment_types: {
        cash: 0,
        credit_cart: 0,
        eft: 0
      },
      credit_id:null
    }
  },
  watch: {
    payment_types: {
      handler() {
        const values = Object.values(this.payment_types)
        if (values.some(e => e > 0)) {
          const totalPrice = values.reduce((total, num) => total + parseInt(num), 0)
          this.expense.price = totalPrice
        }
      },
      deep: true
    },
  },
  mounted() {
    console.log(this.history)
  },
  methods: {
    ...mapActions(['updateExpense', 'createExpense', 'createPay']),
    saveExpense() {
      this.loadingButton = true;
      if(this.credit_id==null){

        this.error('Borç Seçin!')
        return;
      }
      // create
      this.createPay({
        ...this.expense,
        credit_id:this.credit_id,
        payment_types: this.payment_types,
        payment_type:this.payment_type,
        client_id: this.clientId,
      }).then(() => {
        this.success('ARA ÖDEME BAŞARIYLA OLUŞTURULDU!');
        this.loadingButton = false;
        this.hideModal()

        this.$emit('refresh-table');
      }).catch(error => {
        this.loadingButton = false;
        this.error(error.response.data.message);
      });
    },
    hideModal() {
      this.$emit('hide');
    }
  },
  validations() {
    const data = {};
    data.expense = {};
    data.expense.date = {required};
    // if (this.payment_type != 'multiple_payment')
    data.expense.price = {required}
    return data;
  },
}
</script>
